import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
interface LandingPageProps {
  showSocialProofPopup?: boolean;
}
export function LandingPage({
  showSocialProofPopup = true
}: LandingPageProps) {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-234" data-mp="2zj7058razv7b">
      <HeroSection data-id="element-235" data-mp="2zgua08be6ej6" />
      <ProofSection data-id="element-236" data-mp="33kij4vfo9i6j" />
      <ProblemSection data-id="element-237" data-mp="33jqw49054srv" />
      <SystemSection data-id="element-238" data-mp="33lbrg0ua4fqs" />
      <ModulesSection data-id="element-239" data-mp="33ifsc96p3l0r" />
      <BonusSection data-id="element-240" data-mp="38jlokgzkdqf1" />
      <UrgencySection data-id="element-241" data-mp="38j3kiy6nu7wk" />
      <PricingSection data-id="element-242" data-mp="38itq8yel1el2" />
      <TestimonialsSection data-id="element-243" data-mp="38iag43v6buhl" />
      <GuaranteeSection data-id="element-244" data-mp="3dabubvbwjva9" />
      <FAQSection data-id="element-245" data-mp="3dalhlb5kboc9" />
      <FinalCTA data-id="element-246" data-mp="3db3n6ye47ewu" />
      <Footer data-id="element-247" data-mp="3dbmwjqpp8uz9" />
      {showSocialProofPopup && <PurchasePopup data-id="element-248" data-mp="3i9ommvljluk8" />}
    </main>;
}